// import { setRecentList } from "./methods";

exports.install = function (Vue, options) {
  Vue.prototype.getNewData = function (res) {
    //获取titleblock数据转换
    //console.log(res);
    let data = [];
    let data_ = res;
    for (let i = 0; i < data_.attCtr; i++) {
      var add_data = {};
      //console.log(index);
      add_data.index = i;
      add_data.id = data_.ids[i];
      add_data.defaultValue = data_.defaultValues[i];
      //add_data.editable = data_.editable[i];
      // if (data_.editable[i] == 1) { //是否可编辑
      // 	add_data.editable = true;
      // } else {
      // 	add_data.editable = false;
      // };

      add_data.editable = data_.editable[i] == 1; //是否可编辑
      add_data.listType = data_.listTypes[i];

      add_data.name = data_.names[i]; //key
      add_data.descriptions = data_.descriptions[i];
      if (data_.required[i] == 1) {
        //是否必填
        add_data.required = true;
      } else {
        add_data.required = false;
      }
      add_data.uiType = data_.uiTypes[i]; //val的类型
      if (data_.listIds[i] == "-1") {
        add_data.listId = "";
      } else {
        add_data.listId = data_.listIds[i]; //下拉菜单的类型号
      }
      let val = data_.listIds[i];
      let key = data_.listEntries;
      //console.log('999999',key);
      if (key && key[val + ""]) {
        var listEntrie_ = [];
        var old_data = key[val + ""];
        var key_ = Object.keys(old_data);
        var val_ = Object.values(old_data);
        // console.log(33333,val_);
        //console.log(key_);
        for (let j = 0; j < key_.length; j++) {
          if (key_[j] == -1) {
            val_[j] = val_[j].replace(/entryValue/g, "label");
            val_[j] = val_[j].replace(/pid/g, "value");
            let m = JSON.parse(val_[j])[0];
            // console.log(val_);
            // this.delChild(val_);
            this.del(m);
            listEntrie_ = listEntrie_.concat(m);
            // add_data.listType = 2
          } else if (add_data.listType == 3) {
            listEntrie_ = [];
          } else {
            listEntrie_.push({ id: key_[j], name: val_[j] });
          }
        }
        //console.log(listEntrie_);
        add_data.listEntrie = listEntrie_;
      } else {
        add_data.listEntrie = "";
      }
      //console.log(add_data);
      data.push(add_data);
    }
    // console.log(data);
    return data;
  };

  Vue.prototype.del = function (arr) {
    let self = this;
    for (let item of arr) {
      delete item.description;
      delete item.enabled;
      delete item.listId;
      delete item.parent;
      delete item.parentEntry;
      if (item.children.length == 0) {
        delete item.children;
      } else if (item.children.length > 0) {
        self.del(item.children);
      }
    }
    return arr;
  };

  Vue.prototype.unique = function (totalList) {
    var temp = []; //一个新的临时数组
    for (var i = 0; i < totalList.length; i++) {
      if (temp.indexOf(totalList[i]) == -1) {
        temp.push(totalList[i]);
      }
    }
    return temp;
  };
  Vue.prototype.arrayToString = function (res) {
    //下拉菜单数组转对象
    var str = "";
    for (var i = 0; i < res.length; i++) {
      str += res[i] + ";";
    }
    if (res.length > 0) {
      str = str.substr(0, str.length - 1);
    }
    return str;
  };
  Vue.prototype.params = function (obj) {
    //url地址挂参数
    let result = "";
    let item;
    for (item in obj) {
      result += `&${item}=${obj[item]}`;
    }
    if (result) {
      result = "?" + result.slice(1);
    }
    return result;
  };
  Vue.prototype.getNewObj = function (obj) {
    //获取到bom--change下拉菜单进行格式转换(旧)
    var new_obj = [];
    for (var key in obj) {
      var res = {};
      res.id = key;
      if (obj[key] == "") {
        res.text = this.$t("message.title.initial");
      } else {
        res.text = obj[key];
      }
      new_obj.push(res);
    }
    return new_obj;
  };
  Vue.prototype.getChangeSelect = function (param) {
    //获取到bom--change下拉菜单
    // var new_obj = [];

    const { displayValues, changes } = param;
    const arr = (changes || []).map((i, e) => {
      const { id, classId, subClassId } = i;
      const text = displayValues[e] || this.$t("message.title.initial");
      return { id, classId, subClassId, text }

    })
    return arr;
    // var listText = res.displayValues;
    // var listId = res.changes;
    // if (listId.length == 0) {
    //   return false;
    // } else {
    //   for (var i = 0; i < listId.length; i++) {
    //     var obj = {};
    //     obj.id = listId[i].id;
    //     if (listId[i].id == 0) {
    //       obj.text = this.$t("message.title.initial");
    //     } else {
    //       obj.text = listText[i];
    //     }
    //     new_obj.push(obj);
    //   }
    // }
    // return new_obj;
  };
  Vue.prototype.objectDelConfirm = function (method) {
    this.$alert("该对象已被删除", this.$t("message.tips.tip"), {
      confirmButtonText: "确定",
      callback: (_) => {
        this.$emit(medthod, ["", this.$store.state.objectId.id]);
      },
    });
  };
  Vue.prototype.getNewTableData = function (res) {
    //获取到table进行格式转换
    //console.log(res);
    let newData = {};
    let data = [];
    var keys = Object.keys(res);
    //console.log(keys);
    newData.attCtr = res.attCtr;
    newData.listEntries = res.listEntries;
    delete res["attCtr"];
    delete res["listEntries"];
    //console.log(res.length);
    for (var i = 0; i < newData.attCtr; i++) {
      var add_data = {};
      for (var key in res) {
        var a = res[key][i];
        var b = key;
        add_data[b] = a;
      }
      data.push(add_data);
    }
    newData.tableValue = data;
    return newData;
  };
  //和getNewTableContentData几乎一样，只是把“if (rows_type[j] == 4 && rows_editable[j] == 1)”去掉了
  Vue.prototype.getNewChildrenTableContentData = function (res, projectName) {
    //获取到table进行格式转换
    //console.log(res);
    var data = [];
    // console.log(res);
    var rows_val = res.object.table.rows;
    var rows_type = res.object.table.columnInfo.uiTypes;
    var rows_editable = res.object.table.columnInfo.editable;

    const listEntries = res.object.table.columnInfo.listEntries || [];
    const listEntriesKeys = Object.keys(listEntries);
    const caslistEntries = listEntriesKeys.filter(
      (i) => Object.keys(listEntries[i]) == -1
    );

    let casList = [];
    let ids = res.object.table.columnInfo.listIds;
    caslistEntries.map((i) => {
      ids.map((j, e) => j == i && casList.push(e));
    });

    for (var i = 0; i < rows_val.length; i++) {
      var rols_ = {};
      //console.log(rows_val[i]);
      // const ee=  rows_type[j]
      let cellDisable = [];
      let changeIdIndex = 0; //获取表格变更列的版本id
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (res.object.table.columnInfo.ids[j] == 1003116) {
          //获取表格变更列的版本id
          changeIdIndex = j;
        }
        if (rows_val[i].cells[j] == null) {
          (rols_[j] = "");
          // cellDisable.push("null");
        } else {
          cellDisable.push(false)
          // console.log(rows_val[i].cells[j]);
          // cellDisable.push(rows_val[i].cells[j].editable);
          //rols_[j] = rows_val[i].cells[j].val;
          // if(rows_type[j] == 3 && casList.includes(j)){
          // 	rols_[j] = rows_val[i].cells[j].id == -1 ? '': rows_val[i].cells[j].id;
          // }
          if (rows_type[j] == 3) {
            if (casList.includes(j)) {
              rols_[j] =
                rows_val[i].cells[j].id == -1 ? "" : rows_val[i].cells[j].id;
            } else {
              const val = rows_val[i].cells[j];
              rols_[j] =
                !rows_editable[j] || (val.val && ids[j] == -1)
                  ? val.val
                  : val.id;
            }
          } else if (rows_type[j] == 6) {
            if (rows_val[i].cells[j].val == "") {
              rols_[j] = "";
            } else {
              rols_[j] = this.format(
                rows_val[i].cells[j].val,
                "yyyy-MM-dd hh:mm:ss"
              );
            }
            // console.log(rols_[j]);
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }
        }
      }
      if (rows_val[i].hasChildren == true) {
        rols_["hasChildren"] = rows_val[i].hasChildren;
      }
      rols_["cellDisable"] = cellDisable;
      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;
      rols_.objectId = {
        id: rows_val[i].objId,
        classId: rows_val[i].objClass,
        subClassId: rows_val[i].objSubClass,
        name: "",
      };
      rols_["rowId"] = rows_val[i].rowId;
      rols_["fileId"] = rows_val[i].fileId;
      rols_["authTag"] = rows_val[i].authTag;
      rols_["filePath"] = rows_val[i].filePath;
      if (projectName == "performance") {
        rols_["changeId"] = "";
      } else {
        rols_["changeId"] = rows_val[i].cells[changeIdIndex].id; //获取表格变更列的版本id
      }
      data.push(rols_);
      //console.log(this.rols_text);
      //console.log(this.rols_text);
    }
    return data;
  };
  Vue.prototype.getNewTableContentData = function (res, projectName) {
    //获取到table进行格式转换
    console.log(res);
    var data = [];
    // console.log(res);
    var rows_val = res.object.table.rows == null ? [] : res.object.table.rows;
    var rows_type = res.object.table.columnInfo.uiTypes;
    var rows_editable = res.object.table.columnInfo.editable;

    const listEntries = res.object.table.columnInfo.listEntries || [];
    const listEntriesKeys = Object.keys(listEntries);
    const caslistEntries = listEntriesKeys.filter(
      (i) => Object.keys(listEntries[i]) == -1
    );
    const relTypeList = [{ id: 4, icon: "el-icon-connection" }];

    let casList = [];
    let ids = res.object.table.columnInfo.listIds;
    caslistEntries.map((i) => {
      ids.map((j, e) => j == i && casList.push(e));
    });

    const enabled_ids = [1090002, 1092004];
    const enabled_indexs = res.object.table.columnInfo.ids.findIndex((i) =>
      enabled_ids.includes(i)
    );

    for (var i = 0; i < rows_val.length; i++) {
      var rols_ = {};
      // console.log(rows_val[i]);
      let cellDisable = [];
      let changeIdIndex = 0; //获取表格变更列的版本id
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (res.object.table.columnInfo.ids[j] == 1003116) {
          //获取表格变更列的版本id
          changeIdIndex = j;
        }

        if (rows_val[i].cells[j] == null) {
          (rols_[j] = ""), cellDisable.push("null");
        } else {
          // console.log(rows_val[i].cells[j]);
          cellDisable.push(rows_val[i].cells[j].editable);
          //rols_[j] = rows_val[i].cells[j].val;
          // && rows_editable[j] == 1
          if (rows_type[j] == 4) {
            rols_[j] = rows_val[i].cells[j]?.ids || "";
            // rols_[j] = rows_val[i].cells[j].ids;
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
          } else if (rows_type[j] == 3) {
            if (casList.includes(j)) {
              rols_[j] =
                rows_val[i].cells[j].id == -1 ? "" : rows_val[i].cells[j].id;
            } else {
              const val = rows_val[i].cells[j];
              rols_[j] =
                !rows_editable[j] || (val.val && ids[j] == -1)
                  ? val.val
                  : val.id;
            }

            //console.log(j);
            // console.log(rows_val[i].cells[j]);
          } else if (rows_type[j] == 6) {
            if (rows_val[i].cells[j].val == "") {
              rols_[j] = "";
            } else {
              rols_[j] = this.format(
                rows_val[i].cells[j].val,
                "yyyy-MM-dd hh:mm:ss"
              );
            }
            // console.log(rols_[j]);
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }
        }
      }
      if (rows_val[i].hasChildren == true) {
        rols_["hasChildren"] = rows_val[i].hasChildren;
      }
      rols_["cellDisable"] = cellDisable;
      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;
      rols_["relType"] =
        relTypeList.find((item) => item.id == (rows_val[i]?.relType || ""))
          ?.icon || "";

      rols_.objectId = {
        id: rows_val[i].objId,
        classId: rows_val[i].objClass,
        subClassId: rows_val[i].objSubClass,
        name: "",
      };
      rols_["rowId"] = rows_val[i].rowId;
      rols_["fileId"] = rows_val[i].fileId;
      rols_["authTag"] = rows_val[i].authTag;
      rols_["filePath"] = rows_val[i].filePath;

      rols_["hasRev"] = rows_val[i].hasRev;
      rols_["isBOM"] = rows_val[i].isBOM;
      rols_["isFile"] = rows_val[i].isFile;

      rols_["revNumberList"] = rows_val[i].revNumberList;

      if (enabled_indexs != -1) {
        rols_["status"] = rows_val[i].cells[enabled_indexs].id == 1;
      }

      if (projectName == "performance") {
        rols_["changeId"] = "";
      } else {
        rols_["changeId"] = rows_val[i].cells[changeIdIndex].id; //获取表格变更列的版本id
      }
      data.push(rols_);
      //console.log(this.rols_text);
      //console.log(this.rols_text);
    }
    //console.log(data);
    return data;
  };
  Vue.prototype.getNewTableTitleData = function (res, isCheckBox) {
    //获取到table表头进行格式转换
    //console.log(res);
    let data = [];
    if (isCheckBox !== "noCheckBox") {
      let obj = {
        type: "checkbox",
        width: 45,
        fixed: null,
      };
      data.push(obj);
    }
    let list = [
      1003001,
      1005001,
      1006001,
      1007007,
      2000001,
      1008001,
      1009001,
      1090001,
      1096001,
      1017001,
      1013002,
      1010002,
      1015002,
      1014002,
      1095002,
      1094002,
      1018001,
      1093001,
      1055001,
      1054001,
      4012001,
      4011002,
      5013002,
      5014001,
      1025004,
      5015001,
      5011001,
      5012007,
      5021001,
      5022001,
      5016001,
      5017001,
      1024001,
    ];

    var table_title = res.object.table.columnInfo;

    console.log(table_title);
    // var table_title_name = table_title.names;
    // var select_list = table_title.listEntries;
    var data_length = table_title.attCtr;
    //console.log(table_title);
    let Arrowlist = [1003001, 5013002];
    for (let i = 0; i < data_length; i++) {
      var obj = {
        showOverflow: 'title',
        minWidth: 120,
        title: table_title.names[i],
        field: i + "",
        attid: table_title.ids[i],
        sortable: true, //列表排序
        editable: table_title.editable[i] == 1,
        uiType: table_title.uiTypes[i],
        listType: table_title?.listTypes ? table_title.listTypes[i] : 1,
        listId: table_title.listIds[i],
        treeNode: Arrowlist.includes(table_title.ids[i]), //是否有子菜单的箭头显示
        editRender: {
          enabled: table_title.editable[i] == 1,
        },
      };

      // if (i == 0) {
      // 	obj.treeNode = true; //是否有子菜单的箭头显示
      // };
      const e = table_title.ids[i];
      if (list.includes(e)) {
        obj.slots = {
          default: ({ row, column }, h) => {
            // 渲染链接
            return [
              <span
                class="link_"
                onClick={() => this.showDetailEvent(row, column)}
              >
                {" "}
                {row[column.property]}{" "}
              </span>,
            ];
          },
        };
      }
      if (e == 1016001 || e == 1016016) {
        obj.slots = {
          default: ({ row, column }, h) => {
            // 渲染链接
            return [
              <span class="link_" onClick={() => this.toLink(row, column)}>
                {" "}
                {row[column.property]}{" "}
              </span>,
            ];
          },
        };
      }

      if (table_title.uiTypes[i] == 1) {
        obj.editRender = {
          name: "$input",
          // maxlength: '3'
          props: {
            maxlength: "240",
          },
        }; //不设置则不进入编辑模式
      } else if (table_title.uiTypes[i] == 2) {
        obj.editRender = {
          name: "textarea",
          // maxlength: '3'
          props: {
            maxlength: "4000",
          },
        };
      } else if ([3, 4].includes(table_title.uiTypes[i])) {
        var select_id = table_title.listIds[i];
        //console.log(select_id);
        // var val = table_title.listEntries[select_id] || {};
        var val =
          select_id === -1 ? {} : table_title.listEntries[select_id] || {};

        let editRender = {
          name: "$select",
          props: {
            clearable: true,
            multiple: table_title.uiTypes[i] === 4,
          },
          options: [],
        };
        if (select_id != -1) {
          for (const e in val) {
            editRender.options.push({ value: e, label: val[e] });
          }
        }
        obj.editRender = editRender;
      } else if (table_title.uiTypes[i] == 6) {
        obj.editRender = {
          name: "$input",
          props: {
            type: "datetime",
            //labelFormat: 'yyyy-MM-dd HH:mm:ss'
            // labelFormat: 'yyyy-MM-ddThh:mm:ss',
            // valueFormat: 'yyyy-MM-ddThh:mm:ss',
            transfer: true,
          },
        };
        // console.log("!");
      } else if (table_title.uiTypes[i] == 7) {
        obj.editRender = {
          name: "$input",
          props: {
            type: "number",
            clearable: true,
          },
        };
      } else if (table_title.uiTypes[i] == 10) {
        obj.editRender = {
          name: "$input",
          props: {
            type: "number",
            clearable: true,
          },
        };
      }

      // if (table_title.editable[i] == 1) {

      // } else { };

      if (table_title.visible[i] !== 0) {
        data.push(obj);
      }

      obj.editRender.enabled = !!obj.editable;
    }
    //console.log(data);
    return data;
  };

  Vue.prototype.deepClone = function (obj) {
    let _tmp = JSON.stringify(obj); //将对象转换为json字符串形式
    let result = JSON.parse(_tmp); //将转换而来的字符串转换为原生js对象
    return result;
  };

  Vue.prototype.contrastData = function (oldData, newData) {
    //新旧对象数据对比
    var obj = {};
    for (let key in newData) {
      //校验已经修改的数据
      if (oldData[key] !== newData[key]) {
        obj[key] = newData[key];
      }
    }
    return obj;
  };

  Vue.prototype.getNewAdminP1Content = function (res) {
    //获取到table进行格式转换
    //console.log(res);
    var data = [];
    //console.log(res.length);
    var rows_val = res.data.object.colInfo;
    for (var i = 0; i < rows_val.attCtr; i++) {
      var obj = {};
      obj.orders = rows_val.orders[i];
      obj.names = rows_val.names[i];
      obj.id = rows_val.ids[i];
      switch (rows_val.uiTypes[i]) {
        case 1:
          obj.uiType = this.$t("message.table.text");
          break;
        case 2:
          obj.uiType = this.$t("message.table.textarea");
          break;
        case 3:
          obj.uiType = this.$t("message.table.selectList");
          break;
        case 4:
          obj.uiType = this.$t("message.table.multilist");
          break;
        case 6:
          obj.uiType = this.$t("message.table.date");
          break;
        case 7:
          obj.uiType = this.$t("message.table.number");
          break;
        case 8:
          obj.uiType = "Heading";
          break;
        case 10:
          obj.uiType = this.$t("message.table.money");
          break;
        default:
          obj.uiType = this.$t("message.table.richText");
      }
      switch (rows_val.visible[i]) {
        case 1:
          obj.visible = this.$t("message.table.yes");
          break;
        default:
          obj.visible = this.$t("message.table.no");
      }
      switch (rows_val.required[i]) {
        case 1:
          obj.required = this.$t("message.table.yes");
          break;
        default:
          obj.required = this.$t("message.table.no");
      }
      //console.log(obj);
      data.push(obj);
    }
    return data;
  };

  Vue.prototype.getNewAdminP1EditData = function (res) {
    //获取到table进行格式转换
    //console.log(res);
    var data = [];
    var rows_val = res.data.object.properties;

    for (var i = 0; i < rows_val.length; i++) {
      if (rows_val[i].propertyType == 1) {
        var obj = {};
        obj.name = this.$t("message.table.name");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue;
        obj.propertyType = 1;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 2) {
        var obj = {};
        obj.name = this.$t("message.table.des");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue;
        obj.propertyType = 2;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 4) {
        var obj = {};
        obj.name = this.$t("message.table.visible");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue + "";
        obj.propertyType = 4;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 11) {
        var obj = {};
        obj.name = this.$t("message.table.orders");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue;
        obj.propertyType = 11;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 5) {
        var obj = {};
        obj.name = this.$t("message.table.required");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue + "";
        obj.propertyType = 5;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 6) {
        var obj = {};
        obj.name = this.$t("message.table.property");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue;
        obj.propertyType = 6;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 7) {
        var obj = {};
        obj.name = this.$t("message.table.list");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        if (rows_val[i].propertyValue == "-1") {
          obj.val = "";
        } else {
          obj.val = rows_val[i].propertyValue + "";
        }
        obj.editable = rows_val[i].readOnly;
        obj.propertyType = 7;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 8) {
        var obj = {};
        obj.name = this.$t("message.table.type");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue + "";
        obj.propertyType = 8;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
      if (rows_val[i].propertyType == 12) {
        var obj = {};
        obj.name = this.$t("message.table.defaultValue");
        obj.id = rows_val[i].id;
        obj.parentId = rows_val[i].parentId;
        obj.val = rows_val[i].propertyValue + "";
        obj.propertyType = 12;
        obj.editable = rows_val[i].readOnly;
        data.push(obj);
      }
    }
    //console.log(data);
    return data;
  };

  Vue.prototype.getNewAdminP1EditContentView = function (res) {
    //获取到table进行格式转换
    //console.log(res);
    var data = [];
    for (var i = 0; i < res.length; i++) {
      var obj = {};
      switch (res[i].propertyType) {
        case 1:
          obj.name = this.$t("message.table.name");
          obj.val = res[i].val;
          data.push(obj);
          break;
        case 2:
          obj.name = this.$t("message.table.des");
          obj.val = res[i].val;
          data.push(obj);
          break;
        case 4:
          obj.name = this.$t("message.table.visible");
          if (res[i].val == "1") {
            obj.val = this.$t("message.table.yes");
          } else {
            obj.val = this.$t("message.table.no");
          }
          data.push(obj);
          break;
        case 11:
          obj.name = this.$t("message.table.orders");
          obj.val = res[i].val;
          data.push(obj);
          break;
        case 5:
          obj.name = this.$t("message.table.required");
          if (res[i].val == "1") {
            obj.val = this.$t("message.table.yes");
          } else {
            obj.val = this.$t("message.table.no");
          }
          data.push(obj);
          break;
        case 6:
          obj.name = this.$t("message.table.property");
          obj.val = res[i].val;
          data.push(obj);
          break;
        case 7:
          obj.name = this.$t("message.table.list");
          obj.val = res[i].val;
          data.push(obj);
          break;
        case 8:
          obj.name = this.$t("message.table.type");
          if (res[i].val == "1") {
            obj.val = this.$t("message.table.text");
          }
          if (res[i].val == "2") {
            obj.val = this.$t("message.table.textarea");
          }
          if (res[i].val == "3") {
            obj.val = this.$t("message.table.selectList");
          }
          if (res[i].val == "4") {
            obj.val = this.$t("message.table.multilist");
          }
          if (res[i].val == "6") {
            obj.val = this.$t("message.table.date");
          }
          if (res[i].val == "7") {
            obj.val = this.$t("message.table.number");
          }
          if (res[i].val == "8") {
            obj.val = "Heading";
          }
          data.push(obj);
          break;
        default:
      }
    }
    //console.log(data);
    return data;
  };

  Vue.prototype.getNewAdminP1EditContent = function (res) {
    //获取到table进行格式转换
    console.log(res);
    var data = {};
    var readOnly = {};
    let isMultiple = false;
    for (var i = 0; i < res.length; i++) {
      if (res[i].propertyType == 8 && res[i].val == 4) {
        isMultiple = true;
      }
      if (res[i].propertyType == 12 && isMultiple) {
        // data[res[i].propertyType] = res[i].val.split(";");
        let values = res[i].val.split(";");
        if (values == "") {
          data[res[i].propertyType] = [];
        } else {
          data[res[i].propertyType] = values;
        }
      } else {
        data[res[i].propertyType] = res[i].val;
      }
      if (res[i].editable == 0) {
        readOnly[res[i].propertyType] = false;
      } else {
        readOnly[res[i].propertyType] = true;
      }
    }
    var data1 = {
      val: data,
      readOnly: readOnly,
    };
    return data1;
  };

  Vue.prototype.getNewRedLineTableContentData = function (res) {
    //获取到table进行格式转换
    //console.log(res);
    var data = [];
    //console.log(res.length);
    var rows_val = res.object.table.rows;
    var rows_type = res.object.table.columnInfo.uiTypes;
    var rows_editable = res.object.table.columnInfo.editable;
    for (var i = 0; i < rows_val.length; i++) {
      var rols_ = {};
      var rols_child = {};
      var redLine = [];
      //console.log(this.rols[i].cells);
      if (rows_val[i].redlineType == 1) {
        for (var j = 0; j < rows_val[0].cells.length; j++) {
          if (rows_val[i].cells[j] == null) {
            rols_[j] = "";
          } else {
            // rols_[j] = rows_val[i].cells[j].val;

            if (rows_type[j] == 4 && rows_editable[j] == 1) {
              rols_[j] = rows_val[i].cells[j]?.ids || "";
              if (rols_[j] !== "") {
                rols_[j] = rols_[j].split(";");
              }
            } else {
              rols_[j] = rows_val[i].cells[j].val;
            }

            redLine.push(j + 1);
          }
        }
        rols_["itemId"] = rows_val[i].objId;
        rols_["itemClassId"] = rows_val[i].objClass;
        rols_["itemSubClassId"] = rows_val[i].objSubClass;
        rols_.objectId = {
          id: rows_val[i].objId,
          classId: rows_val[i].Class,
          subClassId: rows_val[i].objSubClass,
          name: "",
        };
        rols_["rowId"] = rows_val[i].rowId;
        rols_["parentRowId"] = rows_val[i].parentRowId;
        rols_["redlineType"] = rows_val[i].redlineType;
        rols_["redText"] = redLine;
        data.push(rols_);
      } else if (rows_val[i].redlineType == 2) {
        for (var j = 0; j < rows_val[0].cells.length; j++) {
          if (rows_val[i].cells[j] == null || rows_val[i].cells[j].val == "") {
            rols_[j] = "";
          } else {
            // rols_[j] = rows_val[i].cells[j].val;

            if (rows_type[j] == 4 && rows_editable[j] == 1) {
              rols_[j] = rows_val[i].cells[j].ids;
              if (rols_[j] !== "") {
                rols_[j] = rols_[j].split(";");
              }
            } else {
              rols_[j] = rows_val[i].cells[j].val;
            }

            redLine.push(j + 1);
          }
        }
        rols_["itemId"] = rows_val[i].objId;
        rols_["itemClassId"] = rows_val[i].objClass;
        rols_["itemSubClassId"] = rows_val[i].objSubClass;
        rols_.objectId = {
          id: rows_val[i].objId,
          classId: rows_val[i].Class,
          subClassId: rows_val[i].objSubClass,
          name: "",
        };
        rols_["rowId"] = rows_val[i].rowId;
        rols_["parentRowId"] = rows_val[i].parentRowId;
        rols_["redlineType"] = rows_val[i].redlineType;
        rols_["disable"] = true;
        rols_["redLine"] = redLine;

        data.push(rols_);
      } else if (rows_val[i].redlineType == 3) {
        var showRedline = false;
        for (var j = 0; j < rows_val[0].cells.length; j++) {
          if (rows_val[i].cells[j] == null) {
            rols_[j] = "";
            rols_child[j] = "";
          } else if (rows_val[i].cells[j].val == rows_val[i].oldCells[j].val) {
            rols_child[j] = "";
            // rols_[j] = rows_val[i].cells[j].val;
            if (rows_type[j] == 4 && rows_editable[j] == 1) {
              rols_[j] = rows_val[i].cells[j].ids;
              if (rols_[j] !== "") {
                rols_[j] = rols_[j].split(";");
              }
            } else {
              rols_[j] = rows_val[i].cells[j].val;
            }
          } else {
            // rols_[j] = rows_val[i].cells[j].val;
            // rols_child[j] = rows_val[i].oldCells[j].val;

            if (rows_type[j] == 4 && rows_editable[j] == 1) {
              rols_[j] = rows_val[i].cells[j].ids;
              if (rols_[j] !== "") {
                rols_[j] = rols_[j].split(";");
              }
              rols_child[j] = rows_val[i].oldCells[j].ids;
              if (rols_child[j] !== "") {
                rols_child[j] = rols_child[j].split(";");
              }
            } else {
              rols_[j] = rows_val[i].cells[j].val;
              if (rows_val[i].oldCells[j].val == "") {
                rols_child[j] = "(  )";
              } else {
                rols_child[j] = rows_val[i].oldCells[j].val;
              }
            }

            redLine.push(j + 1);
            showRedline = true;
          }
        }
        rols_["itemId"] = rows_val[i].objId;
        rols_["itemClassId"] = rows_val[i].objClass;
        rols_["itemSubClassId"] = rows_val[i].objSubClass;
        rols_["rowId"] = rows_val[i].rowId;
        rols_["parentRowId"] = rows_val[i].parentRowId;
        rols_["redlineType"] = rows_val[i].redlineType;
        rols_["redText"] = redLine;

        const {
          rowId,
          parentRowId,
          redlineType,
          objId: id,
          objClass: classId,
          objSubClass: subClassId,
        } = rows_val[i];
        rols_.objectId = {
          rowId,
          parentRowId,
          redlineType,
          id,
          classId,
          subClassId,
        };
        data.push(rols_);

        rols_child["disable"] = true;
        rols_child["redLine"] = redLine;
        if (showRedline) {
          data.push(rols_child);
        }

        //console.log(data);
      } else if (rows_val[i].redlineType == 4) {
        for (var j = 0; j < rows_val[0].cells.length; j++) {
          if (rows_val[i].cells[j] == null) {
            rols_[j] = "";
          } else {
            // rols_[j] = rows_val[i].cells[j].val;

            if (rows_type[j] == 4 && rows_editable[j] == 1) {
              rols_[j] = rows_val[i].cells[j].ids;
              if (rols_[j] !== "") {
                rols_[j] = rols_[j].split(";");
              }
            } else {
              rols_[j] = rows_val[i].cells[j].val;
            }
          }
        }

        rols_["itemId"] = rows_val[i].objId;
        rols_["itemClassId"] = rows_val[i].objClass;
        rols_["itemSubClassId"] = rows_val[i].objSubClass;

        const {
          rowId,
          parentRowId,
          redlineType,
          objId: id,
          objClass: classId,
          objSubClass: subClassId,
        } = rows_val[i];
        rols_.objectId = {
          rowId,
          parentRowId,
          redlineType,
          id,
          classId,
          subClassId,
        };
        rols_.objectId = {
          id: rows_val[i].objId,
          classId: rows_val[i].Class,
          subClassId: rows_val[i].objSubClass,
          name: "",
        };
        rols_["rowId"] = rows_val[i].rowId;
        rols_["parentRowId"] = rows_val[i].parentRowId;
        rols_["redlineType"] = rows_val[i].redlineType;

        data.push(rols_);
      }
    }
    return data;
  };

  Vue.prototype.arrayFilter = function (l) {
    let arr = l;
    let list = arr.reduce((pre, cur) => {
      let target = pre.find((ee) => ee.id == cur.id);
      if (target) {
        Object.assign(target, cur);
      } else {
        pre.push(cur);
      }
      return pre;
    }, []);
    return list;
  };

  Vue.prototype.arrGroup = function (data) {
    let arr = data.map((i) => i.id),
      list = [];
    arr = [...new Set(arr)];
    arr.map((i) => {
      let n = data.filter((j) => j.id == i);
      list.push(n);
    });
    let m = list.map((i) => {
      let keys = Object.keys(i);
      let o = {};
      keys.map((j) => {
        Object.assign(o, i[j]);
      });
      return o;
    });
    return m;
  };

  Vue.prototype.null2str = function (data) {
    if (typeof data != "object" || data === null || data === "null") {
      data = "";
      return data;
    } else {
      for (let x in data) {
        if (data[x] === null || data[x] === "null") {
          // 如果是null 把直接内容转为 ''
          data[x] = "";
        } else {
          if (Array.isArray(data[x])) {
            // 是数组遍历数组 递归继续处理
            data[x] = data[x].map((z) => {
              //console.log(z)
              return null2str(z);
            });
          }
          if (typeof data[x] === "object") {
            // 是json 递归继续处理
            data[x] = null2str(data[x]);
          }
        }
      }
      return data;
    }
  };

  Vue.prototype.getUserContextPriv = function () {
    let session_ = window.sessionStorage.getItem("userContext");
    session_ = JSON.parse(session_);
    //console.log(this.userPriveInfo);
    return session_.privs;
  };

  Vue.prototype.filterParams = function (obj) {
    var _newPar = {};
    // for (var key in obj) {
    // //如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。
    // 	if ((obj[key] === 0 ||obj[key] === false|| obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
    // 			_newPar[key] = obj[key];
    // 	}
    // }
    for (const key in obj) {
      // 去除对象内多余的空值key
      if (obj[key] === null) {
        delete obj[key];
      }
    }
    return _newPar;
  };

  Vue.prototype.showDetailEvent = function (row, col) {
    console.log(row);

    // console.log('col===============',col);
    //itemSubClassId
    if (row.itemClassId) {
      this.$emit("routeClick", row, col);
    }
  };

  Vue.prototype.getReqList = function (arr) {
    // console.log(arr);
    let reqList = [];
    for (let i = 0; i < arr.required.length; i++) {
      const e = arr.required[i];
      if (e == 1) {
        reqList.push(arr.ids[i]);
      }
    }
    return reqList;
  };
  (Vue.prototype.getMultiList = function (obj) {
    let arr = [];
    obj.uiTypes.map((i, e) => {
      if (i == 4) {
        return arr.push(obj.ids[e]);
      }
    });
    return arr;
  }),
    (Vue.prototype.getTargetObject = function (targetObject, propsArray) {
      if (typeof targetObject !== "object" || !Array.isArray(propsArray)) {
        throw new Error(this.$t("message.error.param"));
      }
      const result = {};
      Object.keys(targetObject)
        .filter((key) => propsArray.includes(key))
        .forEach((key) => {
          result[key] = targetObject[key];
        });
      return result;
    });
  Vue.prototype.removeEmptyArrayEle = function (arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == undefined) {
        arr.splice(i, 1);
        i = i - 1; // i - 1 ,因为空元素在数组下标 2 位置，删除空之后，后面的元素要向前补位，
        // 这样才能真正去掉空元素,觉得这句可以删掉的连续为空试试，然后思考其中逻辑
      }
    }
    return arr;
  };
  Vue.prototype.timeDiff = function (a, b) {
    // const  n = Math.ceil((Number(new Date(b)) - Number(new Date(a)))/ 1000 / 60 / 60/ 24)
    let n = (Number(new Date(b)) - Number(new Date(a))) / 1000 / 60 / 60 / 24;
    // return n;
    const m1 = new Date(a).getDay();
    if (m1 + n < 7) {
      return n + 1;
    } else if (m1 + n > 7) {
      return (n = n - Math.floor((m1 + n) / 7) * 2 + 1);
    }
  };

  // Vue.prototype.weekendBetween(dtStart, dtEnd) = {
  // 	if (typeof dtEnd == 'string' )
  // 			dtEnd = StringToDate(dtEnd);
  // 	if (typeof dtStart == 'string' )
  // 			dtStart = StringToDate(dtStart);

  // 	var days =  parseInt((dtEnd - dtStart) / 86400000);
  // 	var adds = 0;
  // 	var m = (days+ dtStart.getDay() +1) % 7;
  // 	if(m > 0)
  // 		 adds = m;
  // 	if(m >2)
  // 		 adds = 2;

  // 	var redu = 0
  // 	if(dtStart.getDay() > 0)
  // 		 redu = 2;
  // 	if(dtStart.getDay() ==1)
  // 		 redu =1;

  // 	var subtotal = parseInt((days + dtStart.getDay() +1)/7)*2;
  //  return subtotal - redu + adds;

  // };
  // Vue.prototype.StringToDate(DateStr)
  // {
  // 		var converted = Date.parse(DateStr);
  // 		var myDate = new Date(converted);
  // 	if (isNaN(myDate))
  // 		{
  // 				var arys= DateStr.split('-');
  // 				myDate = new Date(arys[0],arys[1],arys[2]);
  // 		}
  // 		return myDate;
  // };

  Vue.prototype.t2 = function (timestamp) {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + "T" + h + m + s;
  };

  Vue.prototype.isExistingTab = function (e) {
    //console.log(this.$store.getters.getShowingTabInHome);
    const m = this.$store.getters.getShowingTabInHome;
    console.log(m);
    console.log(e);
    if (typeof e == "string") {
      return !!m.map((i) => i.name).includes(e);
    } else {
      const n = m.some(
        (i) => i.objId && i.objId == e.objId && i.objSubClass == e.objSubClass
      );
      // console.log(n);
      if (n) {
        this.$store.commit("setActivedTabInHome", n.name);
        this.$router.push({
          path: n.path,
          query: { isShow: true },
        });
      }
      return n;
    }
    // let isExist = false;
    // for (let position of this.$store.getters.getShowingTabInHome) {
    // 	if (position.name === inputValue) {
    // 		isExist = true;
    // 	}
    // }
    // return isExist;
  };

  // Vue.prototype.getRouteLink = function (e) {
  // 	//this.$store.commit("setClassId", e.itemClassId);
  // 	//this.$store.commit("setObjID", e.itemId);
  // 	//this.$store.commit("setSubClassId", e.itemSubClassId);
  // 	//this.$store.commit("setTabID", 0);
  // 	let n = parseInt(e.itemClassId.toString().substr(0, 3))
  // 	//console.log(n);
  // 	if (n == this.base) {
  // 		this.logoInfo();
  // 		this.tabClick(this.tabList[0], 0);
  // 	}
  // 	let m = {
  // 		title: e[0]||e.name,
  // 		name:'',
  // 		objClass: e.itemClassId,
  // 		objId: e.itemId,
  // 		objSubClass: e.itemSubClassId,
  // 		path:this.getPageUrl(n)
  // 	};
  // 	m.name = ""+ e.itemId + e.itemClassId + e.itemSubClassId;
  // 	//console.log(m);
  // 	if (e.rootId) {
  // 		m.rootId = e.rootId;
  // 	}

  // 	// if (!this.isExistingTab(m)) {
  // 	// 	this.$store.commit("setShowingTabsInHome", m);
  // 	// 	// // this.$store.commit("setActivedTabInHome", m.name);
  // 	// 	// // this.$store.commit("setEditTabsData", m);
  // 	// 	// this.$router.push({
  // 	// 	// 	path: m.path, query: {
  // 	// 	// 		isShow: true
  // 	// 	// 	}
  // 	// 	// })
  // 	// }
  // 	// !this.isExistingTab(m) && this.cc( m);
  // 	if (!this.isExistingTab(m) ) {
  // 		this.$store.commit("setShowingTabsInHome", m);
  // 		this.$store.commit("setActivedTabInHome", m.name);
  // 		this.$router.push({
  // 			path: m.path,
  // 			query: {isShow: true}
  // 	});
  // 	} else{
  // 		this.$store.commit("setActivedTabInHome", m.name);
  //       	this.$router.push({
  // 			path: m.path,
  // 			query: {isShow: true}
  // 	});
  // 	}
  // };
  // Vue.prototype.cc = function(m){
  // 	this.$store.commit("setShowingTabsInHome", m);
  // 	this.$store.commit("setActivedTabInHome", m.name);
  // 	this.$router.push({
  // 		path: m.path,
  // 		query: {isShow: true}
  // 	});
  // }
  Vue.prototype.getPageUrl = function (n) {
    switch (n) {
      case 101:
        return "/item";
      case 104:
        return "/changePage";
      case 105:
        return "/manufactPage";
      case 106:
        return "/manufactPartPage";
      case 901:
        return "/UserItem";
      case 902:
        return "/UserGroupItem";
      case 301:
        return "/project";
      case 401:
        return "/qualityPage";
      case 501:
        return "/technologyPage";
      case 502:
        return "/resourcePage";
    }
  };

  (Vue.prototype.updateTabName = function (e) {
    let tabs = this.$store.getters.getShowingTabInHome; //已存在的list数据
    const n = tabs.findIndex((i) => i.objId == this.$store.state.objectId.id);
    if (tabs[n].title != e) {
      tabs[n].name = e;
      tabs[n].title = e;
      this.$store.commit("replaceShowingTabsInHome", tabs);
      this.$store.commit("setActivedTabInHome", e);
    }
  }),
    (Vue.prototype.format = function (e, type) {
      //时间转换
      if (!e) {
        return "";
      }
      let newDateTime = "";
      if (type == "yyyy-MM-ddThh:mm:ss") {
        var arr = e.split(" ");
        newDateTime = arr[0] + "T" + arr[1];
      } else if (type == "yyyy-MM-dd hh:mm:ss") {
        var arr = e.split("T");
        newDateTime = arr[0] + " " + arr[1];
      }
      return newDateTime;
    });
  (Vue.prototype.getMultiList = function (obj) {
    let arr = [];
    obj.uiTypes.map((i, e) => {
      if (i == 4) {
        return arr.push(obj.ids[e]);
      }
    });
    return arr;
  }),
    (Vue.prototype.deepCopy = function (obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object") {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }),
    (Vue.prototype.isRepeat = function (arr) {
      //console.log(arr);
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    }),
    (Vue.prototype.getParentIdListById = function (list, id) {
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          if (node.id === nodeId) {
            arr.unshift(nodeId);
            if (nodeId === list[0].id) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.id);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    }),
    (Vue.prototype.getParentIdList = function (list, id) {
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          if (node.value === nodeId) {
            arr.unshift(nodeId);
            if (nodeId === list[0].value) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.value);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    }),
    (Vue.prototype.getParentNameList = function (list, id) {
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          if (node.value === nodeId) {
            arr.unshift(node.label);
            if (nodeId === list[0].value) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.value);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    }),
    (Vue.prototype.getParentIdListByPid = function (list, id) {
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          if (node.value === nodeId) {
            arr.unshift(nodeId);
            if (nodeId === list[0].value) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.children) {
              findParent(node.children, nodeId, node.value);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    }),
    (Vue.prototype.getChildrenIdList = function (arr, newArr) {
      console.log(arr);
      newArr = newArr || [];
      let findChildren = (arr, newArr) => {
        arr.map((item) => {
          newArr = newArr || [];
          if (item["id"]) {
            newArr.push(item["id"]);
            if (item["children"]) {
              findChildren(item["children"], newArr);
            }
          }
        });
        return newArr;
      };
      return findChildren(arr);
    }),
    (Vue.prototype.getLeafArray = function (arr, newArr) {
      if (!arr.length) {
        return [];
      }
      newArr = newArr || [];
      let findChildren = (arr, newArr) => {
        for (let i = 0; i < arr.length; i++) {
          newArr = newArr || [];
          const item = arr[i];
          if (item["children"] == null) {
            newArr.push(item);
          } else {
            newArr.push(item);
            findChildren(item["children"], newArr);
          }
        }
        return newArr;
      };
      return findChildren(arr);
    }),
    (Vue.prototype.delChild = function (data) {
      let self = this;
      for (var j = 0; j < data.length; j++) {
        if (data[j].children.length > 0) {
          self.iteration(data[j].children);
        } else {
          // data[j].hasChild = false;
          delete data[j].child;
        }
      }
      return data;
    });
  Vue.prototype.formatList = function (data) {
    let self = this;
    data.map((i) => {
      (i.label = i["1054001"]), (i.value = i["id"]);
      i.disabled = false;
      if (i.children.length) {
        self.formatList(i.children);
      } else {
        delete i.children;
      }
      // return {label : i['1054001'],value : i.id,children:self.formatList(i.children)}
    });
    // for (var j = 0; j < data.length; j++) {
    // 	if (data[j].children.length > 0) {
    // 		self.iteration(data[j].children);
    // 	}
    // 	else {
    // 		// data[j].hasChild = false;
    // 		//delete data[j].child;
    // 	}
    // }
    return data;
  };

  Vue.prototype.iteration = function (data, n = 0) {
    let self = this;
    n = 100 * n + 1;
    for (var j = 0; j < data.length; j++) {
      if (data[j].children.length > 0) {
        data[j].tempId = n;
        n++;
        self.iteration(data[j].children, n + 1);
      } else {
        // data[j].hasChild = false;
        data[j].tempId = n;
        n++;
      }
    }
    return data;
  };

  Vue.prototype.mergeColumnInfo = function (
    fatherColumn,
    childColumn,
    childData
  ) {
    // console.log(fatherColumn);
    // console.log(childColumn);
    // console.log(childData);
    var newData = [];
    for (var k = 0; k < childData.length; k++) {
      var obj = {};
      for (let i = 1; i < fatherColumn.length; i++) {
        var isTure = false;
        var child_num = 0;
        for (let j = 1; j < childColumn.length; j++) {
          if (fatherColumn[i].attid == childColumn[j].attid) {
            isTure = true;
            child_num = j - 1;
          }
        }
        if (isTure) {
          obj[i - 1] = childData[k][child_num];
        } else {
          obj[i - 1] = "";
        }
      }
      // console.log(obj);
      Object.assign(obj, childData[k]);
      // obj["itemId"] = childData[k].itemId;
      // obj["itemClassId"] = childData[k].itemClassId;
      // obj["itemSubClassId"] = childData[k].itemSubClassId;
      // obj["rowId"] = childData[k].rowId;
      // obj["fileId"] = childData[k].fileId;
      // obj["authTag"] = childData[k].authTag;
      // obj["filePath"] = childData[k].filePath;
      // obj["changeId"] = childData[k].changeId;
      // obj["hasChildren"] = childData[k].hasChildren;
      newData.push(obj);
    }
    return newData;
  };

  Vue.prototype.avg = function (arr) {
    var sum = eval(arr.join("+"));
    return ~~((sum / arr.length) * 100) / 100;
  };

  //数组去重复对象
  Vue.prototype.deteleObject = function (obj) {
    var uniques = [];
    var stringify = {};
    for (var i = 0; i < obj.length; i++) {
      var keys = Object.keys(obj[i]);
      keys.sort(function (a, b) {
        return Number(a) - Number(b);
      });
      var str = "";
      for (var j = 0; j < keys.length; j++) {
        str += JSON.stringify(keys[j]);
        str += JSON.stringify(obj[i][keys[j]]);
      }
      if (!stringify.hasOwnProperty(str)) {
        uniques.push(obj[i]);
        stringify[str] = true;
      }
    }
    uniques = uniques;
    return uniques;
  };

  //根据状态disable获取cell的indexId
  Vue.prototype.getTableDisableCell = function (res) {
    let arr = [];
    let data = res.object.table.rows;
    for (var i = 0; i < data.length; i++) {
      let isDisable = false;
      for (var j = 0; j < data[i].cells.length; j++) {
        let rowCell = data[i].cells;
        if (rowCell[j].id == 0) {
          isDisable = true;
        }
      }
      if (isDisable) {
        arr.push(i);
      }
    }
    return arr;
  };

  Vue.prototype.getLink = function (e) {
    let { id, classId, baseId, title, rootId = 0 } = e;
    const subClassId = e.subclassId ?? e.subClassId;

    baseId = baseId || parseInt(classId.toString().substr(0, 3));
    // title = title || '...';
    if (!title) {
      title = e.name ?? "";
    }
    const query = { id, classId, subClassId, baseId, title };
    const path = this.getPageUrl(baseId);

    const name = title + id + classId + subClassId;
    const obj = { name, title, path, query };

    if (rootId) {
      obj.rootId = rootId;
    }
    this.$router.push({ path, query });
    this.$store.dispatch('setTabItem', obj)

  };
};
